import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetAllLimits as GetAllLimitsQuery} from 'nutshell-graphql-types';

import GET_ALL_LIMITS from './graphql/queries/get-all-limits.graphql';

export const useGetAllLimits = () => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetAllLimitsQuery, Record<any, any>>(GET_ALL_LIMITS, {
        fetchPolicy: 'cache-first',
    });

    const allLimits = data ? data.allLimits : null;

    return {
        isLoading,
        allLimits,
        refetch,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
